import { render, staticRenderFns } from "./HealthAction.vue?vue&type=template&id=7308da03"
import script from "./HealthAction.vue?vue&type=script&lang=js"
export * from "./HealthAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports